var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editProcess"}},[(_vm.show)?_c('flowEditor',{ref:"flowEditor",attrs:{"source":"lowcode","noReturn":"","viewMode":_vm.viewMode},on:{"closeDesigner":_vm.close}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }